import React, { FC } from 'react';
import styles from './LandscapeProjectsAddBasicInformationOrganism.module.css';
import cn from 'classnames';
import { Button, Checkbox, Textarea, ValidationForm } from '../../atoms';
import { ImageUploader } from '../../molecules';
import { ProjectResponseDto } from '../../../store/landscapeAPI/project/dto/response/project-response.dto';
import { Form } from 'react-bootstrap';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

export interface LandscapeProjectsAddBasicInformationOrganismProps {
  project: ProjectResponseDto;
  handleOnChange: (project: ProjectResponseDto) => void;
  handleSubmit: () => void;
  openForSupportSelected: boolean;
  setOpenForSupportSelected: React.Dispatch<React.SetStateAction<boolean>>;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
}

const LandscapeProjectsAddBasicInformationOrganism: FC<
  LandscapeProjectsAddBasicInformationOrganismProps
> = ({
  project,
  handleOnChange,
  handleSubmit,
  openForSupportSelected,
  setOpenForSupportSelected,
  handleImageOnChange,
}) => {
  return (
    <div className={cn(styles.landscapeWrapper)}>
      <ValidationForm onSubmitCallback={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control
            type="text"
            value={project.name}
            required
            onChange={(e) =>
              handleOnChange({ ...project, name: e.target.value })
            }
          />
          <Form.Control.Feedback type="invalid">
            Please provide a valid title
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
          <Textarea
            content={project.description ?? ''}
            setContent={(content) => {
              handleOnChange({ ...project, description: content });
            }}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Checkbox
            checked={openForSupportSelected}
            label="Open for support"
            onChange={(checked) => {
              setOpenForSupportSelected(checked);
            }}
            id="support"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <ImageUploader
            setImage={(e) => {
              handleOnChange({ ...project, backgroundImage: e });
            }}
            imageSrc={project.backgroundImage ?? undefined}
            id={project.id}
            setImageMeta={(imageMeta) => handleImageOnChange(imageMeta)}
          />
        </Form.Group>

        <Button className={cn(styles.button)} variant="dark" type="submit">
          Save
        </Button>
      </ValidationForm>
    </div>
  );
};

export default LandscapeProjectsAddBasicInformationOrganism;
